import React from 'react';
import ExpandSideBarItem from './ExpandSideBarItem';
import { shouldHidePWAInstall } from '@utils/pwaUtils';

/**
 * PWA-aware ExpandSideBarItem wrapper
 * Hides the item if PWA is already installed
 */
const PWAExpandSideBarItem = (props) => {
    // Don't render if PWA is already installed
    if (shouldHidePWAInstall()) {
        return null;
    }

    // Render the normal ExpandSideBarItem if PWA is not installed
    return <ExpandSideBarItem {...props} />;
};

export default PWAExpandSideBarItem;